import { render, staticRenderFns } from "./customer-tag.vue?vue&type=template&id=190c5b57&"
import script from "./customer-tag.vue?vue&type=script&lang=js&"
export * from "./customer-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports